/**
 * Design System Icons
 *
 * Auto-generated from Figma Crop Circle System
 * File ID: knAFKgkS8wkIQ47XbZAe4S
 * Node ID: 464-144
 *
 * All icons extracted from Figma with precise SVG values
 */

import { ActivityIcon } from './activityIcon';
import { AddIcon } from './addIcon';
import { AddonsIcon } from './addonsIcon';
import { AlertIcon } from './alertIcon';
import { AndroidIcon } from './androidIcon';
import { AppleIcon } from './appleIcon';
import { ArchiveIcon } from './archiveIcon';
import { ArrowBottomLeftAngleIcon } from './arrowBottomLeftAngleIcon';
import { ArrowBottomRightAngleIcon } from './arrowBottomRightAngleIcon';
import { ArrowLeftIcon } from './arrowLeftIcon';
import { ArrowRightIcon } from './arrowRightIcon';
import { ArrowTopLeftAngleIcon } from './arrowTopLeftAngleIcon';
import { ArrowTopRightAngleIcon } from './arrowTopRightAngleIcon';
import { ArrowUpIcon } from './arrowUpIcon';
import { AtIcon } from './atIcon';
import { AttachmentIcon } from './attachmentIcon';
import { BarnAIcon } from './barnAIcon';
import { BarnBIcon } from './barnBIcon';
import { BarnCIcon } from './barnCIcon';
import { BookmarkIcon } from './bookmarkIcon';
import { BranDIcon } from './branDIcon';
import { BranEIcon } from './branEIcon';
import { CalendarIcon } from './calendarIcon';
import { CameraIcon } from './cameraIcon';
import { CheckIcon } from './checkIcon';
import { ChevronDownIcon } from './chevronDownIcon';
import { ChevronLeftIcon } from './chevronLeftIcon';
import { ChevronRightIcon } from './chevronRightIcon';
import { ChevronUpIcon } from './chevronUpIcon';
import { CircleCheckIcon } from './circleCheckIcon';
import { ClockAIcon } from './clockAIcon';
import { ClockBIcon } from './clockBIcon';
import { ClockCIcon } from './clockCIcon';
import { CommentIcon } from './commentIcon';
import { DeleteIcon } from './deleteIcon';
import { DocumentIcon } from './documentIcon';
import { DocumentBIcon } from './documentBIcon';
import { DotIcon } from './dotIcon';
import { DoubleArrowIcon } from './doubleArrowIcon';
import { DualIcon } from './dualIcon';
import { EditIcon } from './editIcon';
import { FacebookIcon } from './facebookIcon';
import { FilterIcon } from './filterIcon';
import { FlashIcon } from './flashIcon';
import { GoogleIcon } from './googleIcon';
import { GroupsIcon } from './groupsIcon';
import { ImageIcon } from './imageIcon';
import { LinkedinIcon } from './linkedinIcon';
import { LinkIcon } from './linkIcon';
import { LocationIcon } from './locationIcon';
import { MailIcon } from './mailIcon';
import { MicrophoneIcon } from './microphoneIcon';
import { MicrosoftIcon } from './microsoftIcon';
import { MobileIcon } from './mobileIcon';
import { NotScheduledAIcon } from './notScheduledAIcon';
import { NotScheduledBIcon } from './notScheduledBIcon';
import { NotScheduledIcon } from './notScheduledIcon';
import { NoteIcon } from './noteIcon';
import { NotificationIcon } from './notificationIcon';
import { NotificationPlusIcon } from './notificationPlusIcon';
import { PeopleIcon } from './peopleIcon';
import { PinIcon } from './pinIcon';
import { ProfileIcon } from './profileIcon';
import { QrIcon } from './qrIcon';
import { RemoveIcon } from './removeIcon';
import { ReplyIcon } from './replyIcon';
import { ResetIcon } from './resetIcon';
import { RoutineIcon } from './routineIcon';
import { SaveIcon } from './saveIcon';
import { ScheduledIcon } from './scheduledIcon';
import { SearchIcon } from './searchIcon';
import { SettingsIcon } from './settingsIcon';
import { SidechatIcon } from './sidechatIcon';
import { TagIcon } from './tagIcon';
import { VideoIcon } from './videoIcon';
import { XIcon } from './xIcon';
import { YoutubeIcon } from './youtubeIcon';

export * from './types';
export { Icon } from './Icon';
export type { IconComponentProps } from './Icon';

export { ActivityIcon } from './activityIcon';
export { AddIcon } from './addIcon';
export { AddonsIcon } from './addonsIcon';
export { AlertIcon } from './alertIcon';
export { AndroidIcon } from './androidIcon';
export { AppleIcon } from './appleIcon';
export { ArchiveIcon } from './archiveIcon';
export { ArrowBottomLeftAngleIcon } from './arrowBottomLeftAngleIcon';
export { ArrowBottomRightAngleIcon } from './arrowBottomRightAngleIcon';
export { ArrowLeftIcon } from './arrowLeftIcon';
export { ArrowRightIcon } from './arrowRightIcon';
export { ArrowTopLeftAngleIcon } from './arrowTopLeftAngleIcon';
export { ArrowTopRightAngleIcon } from './arrowTopRightAngleIcon';
export { ArrowUpIcon } from './arrowUpIcon';
export { AtIcon } from './atIcon';
export { AttachmentIcon } from './attachmentIcon';
export { BarnAIcon } from './barnAIcon';
export { BarnBIcon } from './barnBIcon';
export { BarnCIcon } from './barnCIcon';
export { BookmarkIcon } from './bookmarkIcon';
export { BranDIcon } from './branDIcon';
export { BranEIcon } from './branEIcon';
export { CalendarIcon } from './calendarIcon';
export { CameraIcon } from './cameraIcon';
export { CheckIcon } from './checkIcon';
export { ChevronDownIcon } from './chevronDownIcon';
export { ChevronLeftIcon } from './chevronLeftIcon';
export { ChevronRightIcon } from './chevronRightIcon';
export { ChevronUpIcon } from './chevronUpIcon';
export { CircleCheckIcon } from './circleCheckIcon';
export { ClockAIcon } from './clockAIcon';
export { ClockBIcon } from './clockBIcon';
export { ClockCIcon } from './clockCIcon';
export { CommentIcon } from './commentIcon';
export { DeleteIcon } from './deleteIcon';
export { DocumentIcon } from './documentIcon';
export { DocumentBIcon } from './documentBIcon';
export { DotIcon } from './dotIcon';
export { DoubleArrowIcon } from './doubleArrowIcon';
export { DualIcon } from './dualIcon';
export { EditIcon } from './editIcon';
export { FacebookIcon } from './facebookIcon';
export { FilterIcon } from './filterIcon';
export { FlashIcon } from './flashIcon';
export { GoogleIcon } from './googleIcon';
export { GroupsIcon } from './groupsIcon';
export { ImageIcon } from './imageIcon';
export { LinkedinIcon } from './linkedinIcon';
export { LinkIcon } from './linkIcon';
export { LocationIcon } from './locationIcon';
export { MailIcon } from './mailIcon';
export { MicrophoneIcon } from './microphoneIcon';
export { MicrosoftIcon } from './microsoftIcon';
export { MobileIcon } from './mobileIcon';
export { NotScheduledAIcon } from './notScheduledAIcon';
export { NotScheduledBIcon } from './notScheduledBIcon';
export { NotScheduledIcon } from './notScheduledIcon';
export { NoteIcon } from './noteIcon';
export { NotificationIcon } from './notificationIcon';
export { NotificationPlusIcon } from './notificationPlusIcon';
export { PeopleIcon } from './peopleIcon';
export { PinIcon } from './pinIcon';
export { ProfileIcon } from './profileIcon';
export { QrIcon } from './qrIcon';
export { RemoveIcon } from './removeIcon';
export { ReplyIcon } from './replyIcon';
export { ResetIcon } from './resetIcon';
export { RoutineIcon } from './routineIcon';
export { SaveIcon } from './saveIcon';
export { ScheduledIcon } from './scheduledIcon';
export { SearchIcon } from './searchIcon';
export { SettingsIcon } from './settingsIcon';
export { SidechatIcon } from './sidechatIcon';
export { TagIcon } from './tagIcon';
export { VideoIcon } from './videoIcon';
export { XIcon } from './xIcon';
export { YoutubeIcon } from './youtubeIcon';

// Icon name mapping for dynamic access
export const iconMap = {
  'Activity': ActivityIcon,
  'Add': AddIcon,
  'Addons': AddonsIcon,
  'Alert': AlertIcon,
  'Android': AndroidIcon,
  'Apple': AppleIcon,
  'Archive': ArchiveIcon,
  'Arrow Bottom Left Angle': ArrowBottomLeftAngleIcon,
  'Arrow Bottom Right Angle': ArrowBottomRightAngleIcon,
  'Arrow Left': ArrowLeftIcon,
  'Arrow Right': ArrowRightIcon,
  'Arrow Top Left Angle': ArrowTopLeftAngleIcon,
  'Arrow Top Right Angle': ArrowTopRightAngleIcon,
  'Arrow Up': ArrowUpIcon,
  'At': AtIcon,
  'Attachment': AttachmentIcon,
  'Barn A': BarnAIcon,
  'Barn B': BarnBIcon,
  'Barn C': BarnCIcon,
  'Bookmark': BookmarkIcon,
  'Bran D': BranDIcon,
  'Bran E': BranEIcon,
  'Calendar': CalendarIcon,
  'Camera': CameraIcon,
  'Check': CheckIcon,
  'Chevron Down': ChevronDownIcon,
  'Chevron Left': ChevronLeftIcon,
  'Chevron Right': ChevronRightIcon,
  'Chevron Up': ChevronUpIcon,
  'Circle Check': CircleCheckIcon,
  'Clock A': ClockAIcon,
  'Clock B': ClockBIcon,
  'Clock C': ClockCIcon,
  'Comment': CommentIcon,
  'Delete': DeleteIcon,
  'Document': DocumentIcon,
  'Document B': DocumentBIcon,
  'Dot': DotIcon,
  'Double Arrow': DoubleArrowIcon,
  'Dual': DualIcon,
  'Edit': EditIcon,
  'Facebook': FacebookIcon,
  'Filter': FilterIcon,
  'Flash': FlashIcon,
  'Google': GoogleIcon,
  'Groups': GroupsIcon,
  'Image': ImageIcon,
  'Linkedin': LinkedinIcon,
  'Link': LinkIcon,
  'Location': LocationIcon,
  'Mail': MailIcon,
  'Microphone': MicrophoneIcon,
  'Microsoft': MicrosoftIcon,
  'Mobile': MobileIcon,
  'Not Scheduled': NotScheduledIcon,
  'Not Scheduled A': NotScheduledAIcon,
  'Not Scheduled B': NotScheduledBIcon,
  'Note': NoteIcon,
  'Notification': NotificationIcon,
  'Notification +': NotificationPlusIcon,
  'People': PeopleIcon,
  'Pin': PinIcon,
  'Profile': ProfileIcon,
  'QR': QrIcon,
  'Remove': RemoveIcon,
  'Reply': ReplyIcon,
  'Reset': ResetIcon,
  'Routine': RoutineIcon,
  'Save': SaveIcon,
  'Scheduled': ScheduledIcon,
  'Search': SearchIcon,
  'Settings': SettingsIcon,
  'Sidechat': SidechatIcon,
  'Tag': TagIcon,
  'Video': VideoIcon,
  'x': XIcon,
  'Youtube': YoutubeIcon,
};

export type IconName = keyof typeof iconMap;
